import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"

export default function Topsellernew() {

  // 配置默认排序
  const defaultSort = {
    sortDirection: "DESC",
    sortBy: "addTime"
  }

  return (
    <>
      <Head>
        <title>{`New Arrivals in New Zealand | Latest Products | Bestdeals.co.nz`}</title>
        <meta name="keywords" content={`best deals nz, best deals, bestdeals nz, bestdeals, new arrival`}></meta>
        <meta name="description" content={`Explore unique new arrivals at Bestdeals.co.nz! Discover fresh stock added daily with amazing discounts. Shop the latest trends and enjoy great sale prices today.`}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout >
        <FeaturedSection type="new-arrival" defaultSort={defaultSort} />
      </DefaultLayout>
    </>
  )
}